import { styled, keyframes } from '@mui/material/styles';

export const LoyaltyPageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f7fa;
  font-family: 'Inter', 'Roboto', sans-serif;
`;

export const HeaderFixed = styled('header')`
  position: sticky;
  top: 0;
  background: #ffffff;
  border-bottom: 1px solid #e0e4ea;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled('div')`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const HeaderInfoItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4a5068;

  & .header-label {
    color: #9ca3af;
    font-weight: 400;
  }

  & .header-value {
    font-weight: 600;
    color: #1a1f36;
  }
`;

export const HeaderDividerVertical = styled('span')`
  width: 1px;
  height: 24px;
  background: #e0e4ea;
`;

export const HeaderRight = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ClientBadgeHeader = styled('div')<{ active: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;

  background: ${({ active }) => (active ? '#ecfdf5' : '#f3f4f6')};
  color: ${({ active }) => (active ? '#059669' : '#9ca3af')};
  border: 1px solid ${({ active }) => (active ? '#a7f3d0' : '#e5e7eb')};

  & .bonus-value {
    font-weight: 700;
  }
`;

export const TabsContainer = styled('div')`
  display: flex;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #e0e4ea;
  padding: 0 20px;
`;

export const TabItem = styled('button')<{
  active: boolean;
  disabled?: boolean;
  completed?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ active, disabled }) => {
    if (disabled) return '#d1d5db';
    if (active) return '#3b5bdb';
    return '#6b7280';
  }};
  border-bottom: 2px solid
    ${({ active }) => (active ? '#3b5bdb' : 'transparent')};
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    color: ${({ active }) => (active ? '#3b5bdb' : '#374151')};
  }
`;

export const TabStepNumber = styled('span')<{
  active: boolean;
  completed?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  transition: all 0.2s ease;

  background: ${({ active, completed, disabled }) => {
    if (completed) return '#059669';
    if (active) return '#3b5bdb';
    if (disabled) return '#e5e7eb';
    return '#e0e4ea';
  }};
  color: ${({ active, completed, disabled }) => {
    if (completed || active) return '#ffffff';
    if (disabled) return '#d1d5db';
    return '#6b7280';
  }};
`;

export const TabConnector = styled('div')<{ completed?: boolean }>`
  width: 32px;
  height: 1px;
  background: ${({ completed }) => (completed ? '#059669' : '#e0e4ea')};
  margin: 0 -4px;
  flex-shrink: 0;
`;

export const ContentArea = styled('main')`
  flex: 1;
  padding: 20px;
  max-width: 90%;
  width: 100%;
  box-sizing: border-box;
`;

export const ClientBlock = styled('div')`
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const BlockTitle = styled('h2')`
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1f36;
`;

export const BlockHint = styled('p')`
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
`;

export const ClientActions = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const OrDivider = styled('span')`
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
`;

export const ScanButton = styled('button')`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: #f0f4ff;
  color: #3b5bdb;
  border: 1px solid #c5d2f6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #dbe4ff;
    border-color: #91a7f2;
  }
`;

export const CodeForm = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;

  & .form-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & .form-block {
    position: relative;
  }

  & .input {
    padding: 10px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    width: 200px;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: #3b5bdb;
      box-shadow: 0 0 0 2px rgba(59, 91, 219, 0.15);
    }
  }

  & .input-error {
    border-color: #ef4444;
  }

  & .error-phone-label {
    position: absolute;
    bottom: -18px;
    left: 0;
    font-size: 12px;
    color: #ef4444;
  }
`;

export const ApplyCodeButton = styled('button')`
  padding: 10px 22px;
  background: #3b5bdb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #2b4acb;
  }

  &:active {
    background: #2040b8;
  }
`;

export const ClientStatus = styled('div', {
  shouldForwardProp: (prop) => prop !== '$added',
})<{ $added: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;

  background: ${({ $added }) => ($added ? '#ecfdf5' : '#fef2f2')};
  color: ${({ $added }) => ($added ? '#059669' : '#dc2626')};
  border: 1px solid ${({ $added }) => ($added ? '#a7f3d0' : '#fecaca')};

  & img {
    flex-shrink: 0;
  }
`;

export const BalanceBadge = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
`;

export const ErrorLabel = styled('div')`
  font-size: 13px;
  color: #ef4444;
  font-weight: 500;
`;

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SuccessToast = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  padding: 12px 16px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 8px;
  color: #059669;
  font-size: 14px;
  font-weight: 500;
  animation: ${fadeSlideIn} 0.3s ease;
`;

export const ReceiptBlock = styled('div')`
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const ReceiptListItem = styled('div')`
  padding: 14px 16px;
  border: 1px solid #e0e4ea;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b5bdb;
    background: #f8f9ff;
  }

  & .receipt-title {
    font-size: 15px;
    font-weight: 600;
    color: #1a1f36;
    margin: 0 0 6px 0;
  }

  & .receipt-product {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.6;
  }
`;

export const ReceiptEmpty = styled('p')`
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  padding: 32px 0;
`;

export const ReceiptChosenHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
`;

export const BackButton = styled('button')`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b5bdb;
    color: #3b5bdb;
  }

  & img {
    width: 16px;
    height: 16px;
    transform: rotate(90deg);
  }
`;

export const LastUpdate = styled('span')`
  font-size: 12px;
  color: #9ca3af;
`;

export const PriceSummary = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;
  padding: 14px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e4ea;
`;

export const PriceRow = styled('div')<{ green?: boolean; bold?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: ${({ green }) => (green ? '#059669' : '#1a1f36')};
  font-weight: ${({ bold, green }) => (bold || green ? '600' : '400')};
`;

export const ProceedButton = styled('button')`
  width: 100%;
  margin-top: 20px;
  padding: 14px 24px;
  background: linear-gradient(135deg, #3b5bdb 0%, #5c7cfa 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(59, 91, 219, 0.3);
  letter-spacing: 0.3px;

  &:hover {
    background: linear-gradient(135deg, #2b4acb 0%, #4c6ef5 100%);
    box-shadow: 0 6px 16px rgba(59, 91, 219, 0.4);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(59, 91, 219, 0.3);
  }
`;

export const TableWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== '$compact',
})<{ $compact?: boolean }>`
  width: 100%;
  overflow-x: ${({ $compact }) => ($compact ? 'visible' : 'auto')};
  border-radius: 10px;
  border: 1px solid #e0e4ea;
`;

export const StyledTable = styled('table', {
  shouldForwardProp: (prop) => prop !== '$compact',
})<{ $compact?: boolean }>`
  width: 100%;
  border-collapse: collapse;
  min-width: ${({ $compact }) => ($compact ? '0' : '560px')};
  table-layout: ${({ $compact }) => ($compact ? 'fixed' : 'auto')};

  ${({ $compact }) =>
    $compact &&
    `
      th, td { padding-left: 6px; padding-right: 6px; }
      th:nth-of-type(1), td:nth-of-type(1) { width: 42%; }
      th:nth-of-type(2), td:nth-of-type(2) { width: 10%; }
      th:nth-of-type(3), td:nth-of-type(3) { width: 16%; }
      th:nth-of-type(4), td:nth-of-type(4) { width: 16%; }
      th:nth-of-type(5), td:nth-of-type(5) { width: 16%; }
      th { white-space: normal; line-height: 1.25; }
      td:first-of-type {
        padding-left: 10px;
        color: #1a1f36;
        font-size: 14px;
        font-weight: 500;
        overflow-wrap: anywhere;
      }
    `}
`;

export const PendingOrderNotice = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid #f6c66f;
  border-radius: 8px;
  background: #fff8e8;
  color: #7a4a00;
  font-size: 13px;
  line-height: 1.45;

  & strong {
    font-size: 14px;
  }
`;

export const THead = styled('thead')`
  background: #f8f9fb;
`;

export const Th = styled('th')`
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  text-align: center;
  border-bottom: 1px solid #e0e4ea;
  white-space: nowrap;

  &:first-of-type {
    text-align: left;
    padding-left: 16px;
    width: 36px;
  }

  &:nth-of-type(2) {
    text-align: left;
  }
`;

export const TBody = styled('tbody')`
  & tr {
    transition: background 0.15s ease;
  }

  & tr:hover {
    background: #f8f9ff;
  }

  & tr:not(:last-child) td {
    border-bottom: 1px solid #f0f1f3;
  }
`;

export const Td = styled('td')<{
  highlight?: boolean;
  strikethrough?: boolean;
}>`
  padding: 12px 12px;
  font-size: 14px;
  color: #1a1f36;
  text-align: center;
  vertical-align: middle;

  &:first-of-type {
    text-align: left;
    padding-left: 16px;
    color: #9ca3af;
    font-size: 13px;
    font-weight: 500;
    width: 36px;
  }

  &:nth-of-type(2) {
    text-align: left;
    font-weight: 500;
  }
`;

export const OldPrice = styled('span')`
  text-decoration: line-through;
  color: #9ca3af;
  font-size: 13px;
  margin-right: 6px;
`;

export const NewPrice = styled('span')`
  color: #1a1f36;
  font-weight: 600;
`;

export const DiscountBadge = styled('span')`
  display: inline-block;
  padding: 2px 8px;
  background: #fef3c7;
  color: #b45309;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const BonusBadge = styled('span')`
  display: inline-block;
  padding: 2px 8px;
  background: #ecfdf5;
  color: #059669;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const EmptyRow = styled('tr')`
  & td {
    padding: 24px;
    text-align: center;
    color: #9ca3af;
    font-size: 14px;
  }
`;

export const OrderSummary = styled('div')`
  width: 100%;
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 10px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OrderSummaryTitle = styled('div')`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
`;

export const OrderSummaryRow = styled('div')<{
  accent?: 'green' | 'orange';
  large?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${({ large }) => (large ? '16px' : '14px')};
  font-weight: ${({ large, accent }) => (large || accent ? '600' : '400')};
  color: ${({ accent, large }) => {
    if (accent === 'green') return '#059669';
    if (accent === 'orange') return '#b45309';
    if (large) return '#1a1f36';
    return '#4a5068';
  }};
`;

export const OrderSummaryDivider = styled('div')`
  height: 1px;
  background: #e0e4ea;
  margin: 4px 0;
`;

export const ApplyBlock = styled('div')`
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const ApplyRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;

export const PrimaryButton = styled('button')<{ disabled?: boolean }>`
  padding: 12px 28px;
  background: ${({ disabled }) => (disabled ? '#d1d5db' : '#3b5bdb')};
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #2b4acb;
  }
`;

export const SecondaryButton = styled('button')<{ disabled?: boolean }>`
  padding: 12px 28px;
  background: ${({ disabled }) => (disabled ? '#f3f4f6' : '#f0f4ff')};
  color: ${({ disabled }) => (disabled ? '#d1d5db' : '#3b5bdb')};
  border: 1px solid ${({ disabled }) => (disabled ? '#e5e7eb' : '#c5d2f6')};
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: #dbe4ff;
  }
`;

export const CodeInputWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  & .react-code-input {
    display: flex !important;
    gap: 6px;
  }

  & .react-code-input > input {
    width: 44px !important;
    height: 48px !important;
    border: 1px solid #d1d5db !important;
    border-radius: 8px !important;
    font-size: 20px !important;
    text-align: center;
    outline: none !important;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: #3b5bdb !important;
      box-shadow: 0 0 0 2px rgba(59, 91, 219, 0.15);
    }
  }
`;

export const QrContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

export const QrPreviewButton = styled('button')`
  border: 2px solid #e0e4ea;
  border-radius: 12px;
  padding: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b5bdb;
    box-shadow: 0 4px 12px rgba(59, 91, 219, 0.15);
  }

  & img {
    display: block;
  }
`;

export const QrModalContent = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  outline: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QrBig = styled('img')`
  width: 320px;
  height: 320px;
  display: block;
`;

export const ApplyError = styled('div')`
  font-size: 13px;
  color: #ef4444;
  font-weight: 500;
  text-align: center;
  padding: 8px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  width: 100%;
`;

export const ApplySuccess = styled('div')<{ error: boolean }>`
  font-size: 14px;
  color: ${({ error }) => (error ? '#ef4444' : '#059669')};
  font-weight: 500;
  text-align: center;
  padding: 12px 16px;
  background: ${({ error }) => (error ? '#fef2f2' : '#ecfdf5')};
  border: 1px solid ${({ error }) => (error ? '#fecaca' : '#a7f3d0')};
  border-radius: 8px;
  width: 100%;
`;

export const OrderInfoBar = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  background: #3b5bdb;
  border-radius: 10px;
  flex-wrap: wrap;
`;

export const OrderInfoLeft = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;

  & .order-line {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.4;
  }
`;

export const OrderInfoRight = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const OrderInfoChip = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;

  & .chip-label {
    color: rgba(255, 255, 255, 0.75);
    font-weight: 400;
  }

  & .chip-value {
    color: #ffffff;
    font-weight: 600;
  }
`;

export const PaymentMethodsRow = styled('div')`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const PaymentMethodCard = styled('div')<{ active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 20px 18px;
  border: 2px solid ${({ active }) => (active ? '#3b5bdb' : '#e0e4ea')};
  border-radius: 12px;
  background: ${({ active }) => (active ? '#f0f4ff' : '#fafafa')};
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b5bdb;
    background: #f0f4ff;
  }
`;

export const PaymentMethodHint = styled('p')`
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  text-align: center;
`;

export const PaymentMethodButton = styled('button')<{
  variant: 'green' | 'orange';
  active?: boolean;
}>`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  width: 100%;

  background: ${({ variant, active }) => {
    if (variant === 'green') return active ? '#047857' : '#10b981';
    return active ? '#c2410c' : '#f97316';
  }};
  color: #ffffff;
  box-shadow: ${({ variant }) =>
    variant === 'green'
      ? '0 4px 12px rgba(16, 185, 129, 0.3)'
      : '0 4px 12px rgba(249, 115, 22, 0.3)'};

  &:hover {
    background: ${({ variant }) =>
      variant === 'green' ? '#047857' : '#c2410c'};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PaymentStatusHint = styled('div')`
  font-size: 13px;
  color: #3b5bdb;
  font-weight: 500;
  text-align: center;
  padding: 8px 12px;
  background: #eef2ff;
  border: 1px solid #c5d2f6;
  border-radius: 8px;
  width: 100%;
  animation: pulse 2s ease-in-out infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

export const PaymentSelectGrid = styled('div')`
  width: 100%;
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 16px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const PaymentSelectCard = styled('div')<{ accent: 'green' | 'blue' }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 22px;
  border-radius: 14px;
  background: #ffffff;
  border: 2px solid
    ${({ accent }) => (accent === 'green' ? '#a7f3d0' : '#c5d2f6')};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

export const PaymentSelectHead = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

export const JanymdaLogo = styled('div')`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, #6a3df5 0%, #3b5bdb 45%, #f97316 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 800;
  font-size: 12px;
  line-height: 1.05;
  letter-spacing: 0.3px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(106, 61, 245, 0.3);
`;

export const PaymentSelectHeadText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PaymentSelectTitle = styled('h3')`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a1f36;
  line-height: 1.35;
`;

export const BeelineBadge = styled('span')`
  align-self: flex-start;
  display: inline-block;
  padding: 3px 10px;
  background: #fde047;
  color: #854d0e;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
`;

export const PaymentSelectDesc = styled('div')`
  font-size: 13px;
  color: #4a5068;
  line-height: 1.6;

  & p {
    margin: 0 0 4px 0;
  }
`;

export const BalanceChip = styled('div')`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
`;

export const InfoHintBar = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  font-size: 12.5px;
  color: #1e40af;
  line-height: 1.5;

  & svg {
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

export const BonusBlock = styled('div')`
  border: 1px solid #a7f3d0;
  background: #f0fdf4;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BonusBlockHead = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #047857;
`;

export const BonusItems = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const BonusItem = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;

  & .bonus-value {
    font-size: 17px;
    font-weight: 800;
    color: #059669;
  }

  & .bonus-label {
    font-size: 11.5px;
    color: #6b7280;
    line-height: 1.4;
  }
`;

export const SelectPaymentButton = styled('button')<{
  accent: 'green' | 'blue';
}>`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 20px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  background: ${({ accent }) =>
    accent === 'green'
      ? 'linear-gradient(135deg, #059669 0%, #10b981 100%)'
      : 'linear-gradient(135deg, #3b5bdb 0%, #5c7cfa 100%)'};
  box-shadow: ${({ accent }) =>
    accent === 'green'
      ? '0 4px 12px rgba(5, 150, 105, 0.3)'
      : '0 4px 12px rgba(59, 91, 219, 0.3)'};

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${({ accent }) =>
      accent === 'green'
        ? '0 6px 16px rgba(5, 150, 105, 0.4)'
        : '0 6px 16px rgba(59, 91, 219, 0.4)'};
  }

  &:active {
    transform: translateY(0);
  }

  & svg {
    flex-shrink: 0;
  }
`;

export const CashierCenter = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  flex: 1;
`;

export const CashierIconCircle = styled('div')`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
`;

export const PaymentMethodsList = styled('ul')`
  margin: 4px 0 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-self: flex-start;

  & li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #4a5068;
  }

  & li::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #3b5bdb;
    flex-shrink: 0;
  }
`;

export const V3BonusScreen = styled('div')`
  padding: 0 !important;
  color: #10213f;
`;

export const V3BonusContent = styled('div')`
  padding: 18px;
`;

export const V3BackButton = styled('button')<{ $inHeader?: boolean }>`
  width: fit-content;
  min-height: 44px;
  margin-bottom: ${({ $inHeader }) => ($inHeader ? '0' : '18px')};
  padding: 0 12px;
  border: 1px solid #c7d1ff;
  border-radius: 8px;
  background: #fff;
  color: #3f56e2;
  font: inherit;
  font-size: var(--v3-control-size, 15px);
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f7f8ff;
  }

  &:focus-visible {
    outline: 3px solid rgba(63, 86, 226, 0.22);
    outline-offset: 2px;
  }
`;

export const V3BonusTitle = styled('h2')`
  margin: 0 0 6px;
  color: #10213f;
  font-size: 20px;
  line-height: 1.35;
`;

export const V3BonusSubtitle = styled('p')`
  margin: 0 0 16px;
  color: #65728a;
  font-size: 14px;
  line-height: 1.45;
`;

export const V3BonusOffer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
  padding: 15px 14px;
  border: 1px solid #75e2b7;
  border-radius: 8px;
  background: #ecfff6;
  color: #007d63;

  span {
    font-size: 14px;
  }

  strong {
    font-size: 22px;
    line-height: 1.25;
  }
`;

export const V3BonusLimitHint = styled('p')`
  margin: -4px 0 16px;
  color: #65728a;
  font-size: 14px;
  line-height: 1.45;
`;

export const V3CodeField = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;

  label {
    color: #10213f;
    font-size: 14px;
  }

  small {
    color: #65728a;
    font-size: 12px;
  }

  > div {
    width: 100% !important;
    display: flex !important;
    gap: 6px;
  }

  input {
    min-width: 0;
    flex: 1 1 0;
    border: 1px solid #9aa8c0 !important;
    border-radius: 7px !important;
    font-family: inherit !important;
    font-size: 22px !important;
  }
`;

export const V3BonusTotals = styled('div')`
  margin-bottom: 12px;
  padding: 14px;
  border: 1px solid #dce3f0;
  border-radius: 8px;
  background: #f7f9fc;

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    min-height: 29px;
    color: #65728a;
    font-size: 14px;
  }

  strong {
    flex: 0 0 auto;
    color: #10213f;
    font-size: 14px;
  }

  .discount strong {
    color: #007d63;
  }

  .payable {
    min-height: 45px;
    margin-top: 7px;
    padding-top: 9px;
    border-top: 1px solid #d5ddea;
    color: #10213f;
    font-weight: 700;
  }

  .payable strong {
    font-size: 20px;
  }
`;

export const V3ReceiptCaption = styled('div')`
  color: #65728a;
  font-size: 12px;
`;

export const V3BonusFooter = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #dce3f0;
`;

export const V3PrimaryButton = styled('button')`
  width: 100%;
  min-height: 48px;
  border: 1px solid #3f56e2;
  border-radius: 8px;
  background: #3f56e2;
  color: #fff;
  font: inherit;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    border-color: #cbd3e7;
    background: #cbd3e7;
    cursor: not-allowed;
  }
`;

export const V3SecondaryButton = styled('button')`
  width: 100%;
  min-height: 48px;
  border: 1px solid #c7d1ff;
  border-radius: 8px;
  background: #f2f4ff;
  color: #3f56e2;
  font: inherit;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ProcessingPage = styled('div')<{ $compact?: boolean }>`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: ${({ $compact }) => ($compact ? '0 !important' : '24px')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? '0' : '18px')};
  overflow: hidden;
`;

export const ProcessingContent = styled('div')<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: ${({ $compact }) => ($compact ? '24px 18px 20px' : '0')};

  @media (max-width: 390px) {
    padding: ${({ $compact }) => ($compact ? '20px 14px 16px' : '0')};
  }
`;

export const ProcessingTitle = styled('h2')<{ $compact?: boolean }>`
  margin: 0;
  font-size: ${({ $compact }) =>
    $compact ? 'var(--v3-title-size, 20px)' : '20px'} !important;
  line-height: 1.35 !important;
  font-weight: 700;
  color: #1a1f36;
  text-align: ${({ $compact }) => ($compact ? 'left' : 'center')};
`;

export const ProcessingLayout = styled('div')<{ $compact?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ $compact }) =>
    $compact ? 'minmax(0, 1fr)' : '1.6fr 1fr'};
  gap: 16px;
  align-items: start;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const ProcessingMain = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProcessingSidebar = styled('aside')`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ProcessingInfoCard = styled('div')<{ $compact?: boolean }>`
  border: 1px solid #e0e4ea;
  border-radius: ${({ $compact }) => ($compact ? '8px' : '12px')};
  background: #ffffff;
  overflow: hidden;
`;

export const ProcessingInfoTitle = styled('div')<{ $compact?: boolean }>`
  padding: 14px ${({ $compact }) => ($compact ? '16px' : '18px')};
  font-size: 15px;
  font-weight: 700;
  color: #1a1f36;
  border-bottom: 1px solid #eef0f3;
`;

export const ProcessingInfoRow = styled('div')<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $compact }) => ($compact ? '16px' : '12px')};
  min-height: ${({ $compact }) =>
    $compact ? 'var(--v3-row-height, 48px)' : 'auto'};
  padding: ${({ $compact }) => ($compact ? '10px 16px' : '13px 18px')};

  &:not(:last-child) {
    border-bottom: 1px solid #f2f3f5;
  }

  & .row-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #f3f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    flex-shrink: 0;
  }

  & .row-label {
    font-size: 14px;
    color: ${({ $compact }) => ($compact ? '#65728a' : '#4a5068')};
    font-weight: ${({ $compact }) => ($compact ? '400' : '500')};
  }

  & .row-value {
    margin-left: auto;
    font-size: 14px;
    font-weight: ${({ $compact }) => ($compact ? '700' : '600')};
    color: #1a1f36;
    display: flex;
    align-items: center;
    gap: 8px;
    text-align: right;
  }
`;

export const PaymentTypePill = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #f0f4ff;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #3b5bdb;

  & svg {
    flex-shrink: 0;
  }
`;

export const StatusChip = styled('span')<{
  tone: 'pending' | 'paid' | 'failed';
}>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;

  background: ${({ tone }) => {
    if (tone === 'paid') return '#ecfdf5';
    if (tone === 'failed') return '#fef2f2';
    return '#eff6ff';
  }};
  color: ${({ tone }) => {
    if (tone === 'paid') return '#059669';
    if (tone === 'failed') return '#dc2626';
    return '#2563eb';
  }};
  border: 1px solid
    ${({ tone }) => {
      if (tone === 'paid') return '#a7f3d0';
      if (tone === 'failed') return '#fecaca';
      return '#bfdbfe';
    }};
`;

/* Заметный индикатор успешной отправки в стандарт */
export const StandartSentBanner = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1.5px solid #34d399;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(16, 185, 129, 0.18);

  & .sent-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #059669;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    flex-shrink: 0;
  }

  & .sent-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  & .sent-title {
    font-size: 15px;
    font-weight: 700;
    color: #047857;
  }

  & .sent-sub {
    font-size: 12.5px;
    color: #059669;
  }
`;

export const ProcessingBanner = styled('div')<{
  tone: 'success' | 'error' | 'pending';
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;

  & svg {
    flex-shrink: 0;
  }

  background: ${({ tone }) => {
    if (tone === 'success') return '#ecfdf5';
    if (tone === 'error') return '#fef2f2';
    return '#eff6ff';
  }};
  color: ${({ tone }) => {
    if (tone === 'success') return '#059669';
    if (tone === 'error') return '#dc2626';
    return '#2563eb';
  }};
  border: 1px solid
    ${({ tone }) => {
      if (tone === 'success') return '#a7f3d0';
      if (tone === 'error') return '#fecaca';
      return '#bfdbfe';
    }};

  ${({ tone }) =>
    tone === 'pending' &&
    `
    animation: procPulse 2s ease-in-out infinite;
    @keyframes procPulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.65; }
    }
  `}
`;

export const RetryStandartButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 20px;
  background: #3b5bdb;
  color: #ffffff;
  border: none;
  min-height: 44px;
  border-radius: 8px;
  font-size: var(--v3-control-size, 15px);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  & svg {
    flex-shrink: 0;
  }

  &:hover {
    background: #2b4acb;
  }

  &:disabled {
    background: #c5d2f6;
    cursor: not-allowed;
  }
`;

export const ProcessingBackButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 20px;
  background: #ffffff;
  color: #3b5bdb;
  border: 1px solid #c5d2f6;
  min-height: 44px;
  border-radius: 8px;
  font-size: var(--v3-control-size, 15px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  & svg {
    flex-shrink: 0;
  }

  &:hover {
    background: #f0f4ff;
    border-color: #91a7f2;
  }
`;

export const SidebarDropdown = styled('button')`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  font-size: 13.5px;
  font-weight: 600;
  color: #1a1f36;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #c5d2f6;
    background: #fafbff;
  }

  & .dropdown-q {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #1cbf45ff;
    color: #ffffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
  }

  & .dropdown-chevron {
    margin-left: auto;
    color: #9ca3af;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &[data-open='true'] .dropdown-chevron {
    transform: rotate(180deg);
  }
`;

export const SidebarDropdownBody = styled('div')`
  padding: 12px 16px 14px 16px;
  margin-top: -8px;
  font-size: 12.5px;
  color: #6b7280;
  line-height: 1.6;
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-top: none;
  border-radius: 0 0 12px 12px;
`;

export const SidebarCard = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;

  & .sidebar-icon {
    flex-shrink: 0;
    color: #3b5bdb;
    margin-top: 1px;
  }

  & .sidebar-content {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  & .sidebar-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a1f36;
  }

  & .sidebar-text {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.55;
  }

  & .sidebar-chevron {
    margin-left: auto;
    color: #9ca3af;
    flex-shrink: 0;
    align-self: center;
  }
`;

export const SidebarImportant = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;

  & .important-shield {
    flex-shrink: 0;
    color: #2563eb;
    margin-top: 1px;
  }

  & .important-content {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  & .important-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #1e40af;
  }

  & .important-text {
    font-size: 12px;
    color: #3b5bdb;
    line-height: 1.55;
  }
`;

export const FaqList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-size: 12.5px;
  color: #4a5068;
  line-height: 1.55;

  & .faq-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  & .faq-title {
    font-weight: 700;
    color: #1a1f36;
  }

  & .faq-sub {
    font-weight: 700;
    color: #1a1f36;
    margin-top: 2px;
  }

  & .faq-indent {
    padding-left: 14px;
  }

  & strong {
    font-weight: 700;
    color: #1a1f36;
  }
`;

export const ModalOverlay = styled('div')`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  outline: none;

  @media (max-width: 640px) {
    padding: 0;
    align-items: flex-end;
  }
`;

export const ModalCard = styled('div')`
  position: relative;
  width: 100%;
  max-width: 900px;
  max-height: 88vh;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);
  padding: 32px 32px 28px;
  outline: none;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e2e5ec;
    border-radius: 3px;
  }

  @media (max-width: 640px) {
    max-width: 100%;
    max-height: 92vh;
    border-radius: 20px 20px 0 0;
    padding: 24px 18px 20px;
  }
`;

export const CloseButton = styled('button')`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #f3f4f7;
  border-radius: 50%;
  color: #4b5160;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #e7e9ee;
  }
`;

export const ModalHeader = styled('div')`
  padding-right: 40px;
  margin-bottom: 20px;
`;

export const ModalTitle = styled('h2')`
  margin: 0 0 8px;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  color: #14161f;

  @media (max-width: 640px) {
    font-size: 19px;
  }
`;

export const ModalSubtitle = styled('p')`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #6b7080;
`;

export const InfoBox = styled('div')`
  display: flex;
  gap: 12px;
  background: #eef3ff;
  border: 1px solid #dbe6ff;
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 24px;

  .info-icon {
    flex-shrink: 0;
    color: #2f6bff;
    margin-top: 1px;
  }

  .info-title {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #1c2b52;
    margin-bottom: 8px;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  li {
    font-size: 13.5px;
    line-height: 1.5;
    color: #33405f;
  }
`;

export const SectionTitle = styled('h3')`
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 700;
  color: #14161f;
`;

export const StepsGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 780px) {
    grid-template-columns: 1fr;
  }
`;

export const StepCard = styled('div')`
  display: flex;
  flex-direction: column;
  border: 1px solid #ecedf1;
  border-radius: 16px;
  padding: 16px;
  background: #fbfbfc;
`;

export const StepHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;

  .step-number {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #16a34a;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step-title {
    font-size: 14.5px;
    font-weight: 700;
    color: #14161f;
  }
`;

export const StepText = styled('p')`
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.5;
  color: #6b7080;
`;

export const StepImageFrame = styled('div')`
  margin-top: auto;
  display: flex;
  justify-content: center;
  border-radius: 32px;
  overflow: hidden;
  background: #f2f3f6;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  img {
    width: 100%;
    max-width: 220px;
    height: auto;
    display: block;
  }
`;

export const AdditionalBox = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #ecfdf3;
  border: 1px solid #d3f5e2;
  border-radius: 14px;
  padding: 16px 18px;

  .additional-icon {
    flex-shrink: 0;
    color: #16a34a;
    margin-top: 1px;
  }

  .additional-title {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #0f5132;
    margin-bottom: 4px;
  }

  .additional-text {
    display: block;
    font-size: 13.5px;
    line-height: 1.5;
    color: #2a5b44;
  }
`;

export const FaqModalCard = styled('div')`
  position: relative;
  width: 100%;
  max-width: 980px;
  max-height: 88vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);
  outline: none;

  @media (max-width: 760px) {
    max-width: 100%;
    max-height: 92vh;
    border-radius: 20px 20px 0 0;
  }
`;

export const FaqModalHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px;
  border-bottom: 1px solid #eef0f3;
  flex-shrink: 0;

  & .faq-modal-icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #1cbf45;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
  }

  & .faq-modal-title {
    font-size: 16px;
    font-weight: 700;
    color: #14161f;
  }
`;

export const FaqModalBody = styled('div')`
  display: grid;
  grid-template-columns: 300px 1fr;
  min-height: 0;
  flex: 1;
  overflow: hidden;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    overflow-y: auto;
  }
`;

export const FaqSidebarColumn = styled('div')`
  border-right: 1px solid #eef0f3;
  padding: 16px 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 760px) {
    border-right: none;
    border-bottom: 1px solid #eef0f3;
    max-height: 260px;
  }
`;

export const FaqGroupLabel = styled('div')`
  margin: 14px 10px 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #9ca3af;
  text-transform: uppercase;

  &:first-of-type {
    margin-top: 4px;
  }
`;

export const FaqListItem = styled('button')<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 9px 10px;
  border: none;
  border-radius: 10px;
  background: ${({ active }) => (active ? '#eef3ff' : 'transparent')};
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ active }) => (active ? '#eef3ff' : '#f5f6f9')};
  }

  & .faq-item-number {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11.5px;
    font-weight: 700;
    background: ${({ active }) => (active ? '#2f6bff' : '#eceef2')};
    color: ${({ active }) => (active ? '#ffffff' : '#6b7080')};
  }

  & .faq-item-text {
    font-size: 13px;
    line-height: 1.4;
    color: ${({ active }) => (active ? '#1c2b52' : '#33405f')};
    font-weight: ${({ active }) => (active ? '600' : '400')};
  }
`;

export const FaqDetailColumn = styled('div')`
  padding: 22px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const FaqDetailTitle = styled('h3')`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #14161f;
  line-height: 1.35;
`;

export const FaqPlainContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13.5px;
  line-height: 1.6;
  color: #33405f;

  & .faq-sub {
    font-weight: 700;
    color: #14161f;
    margin-top: 6px;
  }

  & .faq-indent {
    padding-left: 14px;
  }

  & strong {
    font-weight: 700;
    color: #14161f;
  }
`;

export const FaqHighlightBox = styled('div')`
  background: #eef3ff;
  border: 1px solid #dbe6ff;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 13.5px;
  line-height: 1.6;
  color: #1c2b52;

  & strong {
    font-weight: 700;
  }
`;

export const FaqStepsHeading = styled('div')`
  font-size: 12.5px;
  font-weight: 700;
  color: #6b7080;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const FaqStepsList = styled('ol')`
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13.5px;
  line-height: 1.55;
  color: #33405f;

  & strong {
    font-weight: 700;
    color: #14161f;
  }
`;

export const FaqCtaButton = styled('button')`
  align-self: flex-start;
  margin-top: 4px;
  padding: 10px 20px;
  background: #ffffff;
  color: #2f6bff;
  border: 1.5px solid #2f6bff;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #eef3ff;
  }
`;

export const ScreenWithHint = styled('div')`
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 20px;
  align-items: start;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const HintMainColumn = styled('div')`
  min-width: 0;
`;

export const HintCard = styled('div')`
  position: sticky;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: #ffffff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const HintBadgeRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HintBadgeIcon = styled('div')<{ bg: string }>`
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: ${({ bg }) => bg};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
`;

export const HintCheckIcon = styled('div')`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #059669;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const HintBadgeLabel = styled('span')`
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const HintTitle = styled('h3')`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1f36;
  line-height: 1.3;
`;

export const HintDescription = styled('p')`
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.55;
`;

export const HintSectionLabel = styled('div')`
  font-size: 11.5px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: -6px;
`;

export const HintStepsList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const HintStep = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const HintStepNumber = styled('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #eef1f6;
  color: #4a5068;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 1px;
`;

export const HintStepText = styled('div')`
  font-size: 13px;
  color: #374151;
  line-height: 1.5;

  & strong {
    display: block;
    font-weight: 600;
    color: #1a1f36;
    margin-bottom: 2px;
  }
`;

export const HintTipBox = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
`;

export const HintTipLabel = styled('span')`
  font-size: 11px;
  font-weight: 700;
  color: #2563eb;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const HintTipText = styled('p')`
  margin: 0;
  font-size: 13px;
  color: #1e40af;
  line-height: 1.55;
`;

const blinkBorderRed = keyframes`
  0%, 100% {
    border-color: #eb5757;
  }
  50% {
    border-color: #ffffff;
  }
`;

const blinkTextRed = keyframes`
  0%, 100% {
    color: #eb5757;
  }
  50% {
    color: #3b5bdb;
  }
`;

export const AnnouncementBlock = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px;
  padding: 16px 20px;
  background: #ffffff;
  border: solid 3px #eb5757;
  border-radius: 10px;
  text-align: center;
  animation: ${blinkBorderRed} 1s infinite;

  & h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 5px;
    animation: ${blinkTextRed} 1s infinite;
  }

  & span {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    color: #1a1f36;
    white-space: pre-line;
  }

  @media only screen and (max-width: 1024px) {
    margin: 0 10px 16px;
    padding: 12px 14px;

    & h2 {
      font-size: 16px;
      letter-spacing: 3px;
    }

    & span {
      font-size: 15px;
    }
  }
`;
